import { createSelector } from 'reselect'
import { IStore } from '../../../index'

const getNotifications = function(state: IStore) {
  return (
    state.userAccount.notifications.items
      .filter(not => !not.deletedAt)
      .sort((a, b) => b.createdAt - a.createdAt) || []
  )
}

export default getNotifications

const getNotificationsIds = createSelector(
  [getNotifications],
  notifications => notifications.map(not => not.id),
)

function getNotificationsLoading(state: IStore) {
  return state.userAccount.notifications.isLoading
}

export { getNotificationsIds, getNotificationsLoading }
